import { Maximize, Minimize } from 'lucide-react';
import { FC, ReactNode } from 'react';
import classNames from 'classnames';

import { Button } from '../../../shared/ui';

export interface MeetLayoutVideosTopPanelBottomProps {
  /** Верхняя секция (сетка видео участников) */
  topContent: ReactNode;
  /** Нижняя секция (показ экрана, выбор колоды МАК и т.д.) */
  bottomContent: ReactNode;
  /** При true два ряда участников (>6): верх 30%, низ 70%; иначе один ряд: верх 15%, низ 85% */
  topSectionLarge?: boolean;
  /** Дополнительный класс для нижней секции (например фон) */
  bottomClassName?: string;
  /** При true нижняя панель на всю высоту поверх видео (overlay) */
  bottomExpanded?: boolean;
  /** Переключить развёрнутое состояние нижней панели */
  onBottomExpandToggle?: () => void;
  /** Слой поверх нижней секции (демонстрация экрана при активном инструменте) */
  bottomOverlay?: ReactNode;
}

/**
 * Layout встречи: видео сверху, панель контента снизу.
 * Используется для screen share и для инструмента МАК в групповой терапии.
 */
export const MeetLayoutVideosTopPanelBottom: FC<MeetLayoutVideosTopPanelBottomProps> = ({
  topContent,
  bottomContent,
  topSectionLarge = false,
  bottomClassName,
  bottomExpanded = false,
  onBottomExpandToggle,
  bottomOverlay,
}) => (
  <div className="relative h-full w-full flex flex-col gap-2">
    <div className="flex-shrink-0 w-full min-h-[120px]">{topContent}</div>
    <div
      className={classNames(
        'min-h-0 w-full rounded-chip md:rounded-card overflow-hidden',
        bottomClassName,
        bottomExpanded ? 'absolute inset-0 z-[60] flex flex-col' : 'relative flex-1',
      )}
    >
      <div
        className={classNames('h-full w-full min-h-0', {
          'opacity-0 pointer-events-none': bottomOverlay,
        })}
      >
        {bottomContent}
      </div>
      {onBottomExpandToggle && (
        <Button
          type="button"
          size="sm"
          variant="ghost"
          className="absolute right-[58px] top-5 z-[120] pointer-events-auto"
          aria-label={bottomExpanded ? 'Свернуть панель' : 'Расширить панель'}
          startIcon={bottomExpanded ? <Minimize size={16} aria-hidden /> : <Maximize size={16} aria-hidden />}
          onMouseDown={(event) => {
            event.preventDefault();
            event.stopPropagation();
            onBottomExpandToggle();
          }}
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
          }}
        >
          {bottomExpanded ? 'Свернуть' : 'Расширить'}
        </Button>
      )}
      {bottomOverlay && <div className="absolute inset-0 z-10">{bottomOverlay}</div>}
    </div>
  </div>
);
